import { getCustomersResp } from "./adminObjectMocks/getCustomersResp";
import { getCustomersDataResp } from "./adminObjectMocks/getCustomersDataResp";
import { getCustomerBehavioursResp } from "./adminObjectMocks/getCustomerBehavioursResp";
import { getDeactivatedOperatorsResp } from "./adminObjectMocks/getDeactivatedOperatorsResp";
import { getTargetComponentsResp } from "./adminObjectMocks/getTargetComponentsResp";
import { createAccountsResp } from "./adminObjectMocks/createAccountsResp";
import AppUtils from "@src/utils/appUtils";

export function getCustomers() {
  const response = getCustomersResp;
  return AppUtils.simulateResponse(response);
}

export function getBehaviours() {
  const response = getCustomerBehavioursResp;
  return AppUtils.simulateResponse({ behaviours: response });
}

export function getCustomersData() {
  const response = getCustomersDataResp;
  return AppUtils.simulateResponse(response);
}

export function updateCustomer() {
  return AppUtils.simulateResponse(true);
}

export function createCustomer() {
  return AppUtils.simulateResponse(true);
}

export function createCustomerIdentityPool() {
  return AppUtils.simulateResponse(true);
}

export function createAccounts() {
  const response = createAccountsResp;
  return AppUtils.simulateResponse(response);
}

export function calculateBaselines() {
  const response = { result: 100 };
  return AppUtils.simulateResponse(response);
}

export function updateBehaviours(req) {
  let response = req.behaviours.map((bvr) => {
    return {
      behaviourType: bvr.behaviourType,
      description: bvr.description,
      weight: bvr.weight,
      customerCode: req.customerCode,
      createdDate: bvr.createdDate ? bvr.createdDate : new Date(),
    };
  });
  return AppUtils.simulateResponse(response);
}

export function getOperators(customerCode) {
  let response;
  if (customerCode) {
    response = getDeactivatedOperatorsResp;
  }
  return AppUtils.simulateResponse(response);
}
export function getOperator(operatorId) {
  let response;
  if (operatorId) {
    response = getDeactivatedOperatorsResp.operators[0];
  }
  return AppUtils.simulateResponse(response);
}

export function getDeactivatedOperators(customerCode) {
  let response;
  if (customerCode) {
    response = getDeactivatedOperatorsResp;
  }
  return AppUtils.simulateResponse(response);
}

export function saveActiveOperators() {
  return AppUtils.simulateResponse({
    message: "The selected operators are now active!",
  });
}

export function getTargetComponents() {
  return AppUtils.simulateResponse(getTargetComponentsResp);
}

export function updateTargetModifier() {
  return AppUtils.simulateResponse(true);
}

export const getOperatorNotifications = async (customerCode, operatorCode) => {
  return AppUtils.simulateResponse({ notifications: [] });
};
export const getNotification = async (notificationId) => {
  return AppUtils.simulateResponse({ notification: null });
};
export const getLastSentDates = async (customerCode, template) => {
  return AppUtils.simulateResponse({ lastSentDates: [] });
};
export const getNotificationTemplateConfigs = async () => {
  return AppUtils.simulateResponse([
    {
      _id: "668d316bf4ebe4dc908cdeeb",
      name: "Support",
      description: "Support Email",
      type: ["email"],
      hasAttachments: false,
      customerCode: "DEFAULT",
      templateCode: "SUPPORT",
      sendgridId: "d-ec3c9dab35c44cf39d4c24abd02aeb1b",
    },
  ]);
};
export const getOperatorSignupLink = async (customerCode, operatorCode) => {
  return AppUtils.simulateResponse({ signupLink: "https://demo.signol.app" });
};
export const deployDynamicContent = async (mode) => {
  return AppUtils.simulateResponse(true);
};
export const clearBackendCaches = async () => {
  return AppUtils.simulateResponse(true);
};
export const triggerReportsService = async () => {
  return AppUtils.simulateResponse(true);
};
export const getCustomerLogoUploadUrl = async (customerCode, logoType) => {
  return AppUtils.simulateResponse({
    uploadUrl: `https://demo.signol.app/upload/${customerCode}/${logoType}`,
  });
};
